var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TenantLogo"},[_c('img',{style:(_vm.style),attrs:{"src":_vm.src,"width":_vm.getImage.width,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }